import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import { CloseBox, Loading } from "mdi-material-ui";
import { BookingAuditSearch_RecordFragment as Data } from "@graphql";
import moment from "moment";
import { useUserProfile } from "@hooks";

type Props = {
  data: Data | null;
  onCheck: (v: boolean) => Promise<any>;
  onComment: (s: string) => void;
};

export function WeekStatus(props: Props) {
  const { data } = props;
  const user = useUserProfile();

  const [loading, setLoading] = React.useState(false);
  const [audit, setAudit] = React.useState({} as any);
  const [comment, setComment] = useState("");

  useEffect(() => {
    setAudit({
      approved: data?.Approved,
      setBy: data?.SetBy?.Name,
      setOn: data?.SetOn
    });
    setComment(data?.Comment || "");
  }, [data]);

  const check = (checked: boolean) => {
    setLoading(true);
    props
      .onCheck(checked)
      .then(() =>
        setAudit({
          approved: checked,
          setBy: user.name,
          setOn: new Date()
        })
      )
      .finally(() => setLoading(false));
  };

  let icon: React.ReactNode;
  let checkedIcon: React.ReactNode;

  if (loading) {
    icon = <Loading color="secondary" className="spin-forever" />;
    checkedIcon = icon;
  } else if (audit.setOn && !audit.approved) {
    icon = <CloseBox color="error" />;
  }

  function _setComment(value: string) {
    setComment(value);
    props.onComment(value);
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            checked={!!audit.approved}
            onChange={(_, checked) => check(checked)}
          />
        }
        label={
          <small>
            {audit.setBy ?? ""}
            <br />
            {audit.setOn ? moment(audit.setOn).format("L") : ""}
          </small>
        }
      />
      {!!audit.setOn && (
        <TextField
          onChange={(event) => _setComment(event.target.value)}
          value={comment ? comment : ""}
        />
      )}
    </>
  );
}
